import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { BadgePrimitive } from '../badge-primitive/badge-primitive.js';
import { icon, badgeText, badge, variant, size, hasIconPrefix } from './badge.css.js';

/**
 * Styled Badge component. Badges are used to call attention to status.
 *
 * @see https://fpl.figma.design/components/badge/
 */
const Badge = forwardRef(({ children, variant: variant$1 = 'defaultFilled', size: size$1 = 'md', iconPrefix, ...props }, ref) => {
    return (jsxs(BadgePrimitive, { "data-fpl-component": "", ...props, className: clsx(badge, variant[variant$1], size[size$1], {
            [hasIconPrefix]: !!iconPrefix,
        }), ref: ref, children: [iconPrefix && (jsx("span", { className: icon, "aria-hidden": "true", children: iconPrefix })), jsx("span", { className: badgeText, children: children })] }));
});
Badge.displayName = 'Badge';

export { Badge };
//# sourceMappingURL=badge.js.map
